import { HomepageSettingsEntity } from './homepageSettingsEntity';
import { Email } from './valueObjects/email';
import { NurseryId } from './valueObjects/nurseryId';
import { Tel } from './valueObjects/tel';
import { Url } from './valueObjects/url';

import type {
  HomepageSettingsProps,
} from './homepageSettingsEntity';
import type { HomepageSettingsJson } from '@/types/domain/childApply/entities/homepageSettingsEntity';

import { Factory } from '@/domain/factory';

export class HomepageSettingsFactory extends Factory<
  HomepageSettingsEntity,
  HomepageSettingsProps,
  HomepageSettingsJson
> {
  comparePvt = (a: HomepageSettingsJson, b: HomepageSettingsJson) => {
    const da = a.nurseryId;
    const db = b.nurseryId;
    return da > db ? 1 : -1;
  };

  createPvt(props: HomepageSettingsProps): HomepageSettingsEntity {
    return new HomepageSettingsEntity(props, null);
  }

  createFromJsonPvt(props: HomepageSettingsJson): HomepageSettingsEntity {
    return this.createPvt({
      nurseryId: NurseryId.create(props.nurseryId),
      url: Url.create(props.url),
      tel: Tel.create(props.tel),
      email: Email.create(props.email),
    });
  }
}
